export const Locale = {
  DE: 'de',
  EN: 'en'
} as const;

export type Locale = (typeof Locale)[keyof typeof Locale];

export const TimeLocale = {
  DE: 'de-DE',
  EN: 'en-US'
} as const;

export type TimeLocale = (typeof TimeLocale)[keyof typeof TimeLocale];

export const LocalizationNameSpace = {
  AUTHORIZATION: 'authorization',
  NAVIGATION: '@/navigation',
  GEO_AREA: 'geo-area',
  MY_PLACE: 'my-place',
  PROFILE_SETTING: 'profile-setting',
  ORGANIZATION: 'organization',
  SHARED: '@/shared',
  PRIVACY: 'privacy',
  ONBOARDING: 'onboarding',
  POSTS: 'posts',
  POST_EDITOR: 'post-editor',
  POST_CREATION: 'post-creation',
  SENDER_SELECTION: 'sender-selection',
  GROUPS: 'groups',
  EXPERIMENTS: 'experiments',
  FEATURE_MANAGEMENT: 'feature-management',
  MEDIA: 'media',
  VERIFICATION: 'verification',
  CHATS: 'chats',
  START: 'start',
  FLAGS: 'flags',
  TUTORIAL: 'tutorial',
  API: 'api'
} as const;

export type LocalizationNameSpace =
  (typeof LocalizationNameSpace)[keyof typeof LocalizationNameSpace];
